import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Icon, message, Modal, Button, Select, Skeleton } from 'antd'

import moment from 'moment'

import './styles.scss'

class ColoredCard extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      icon,
      headerStats,
      footerStats,
      number,
      unit,
      title,
      color,
      loading,
      error,
      onClick,
    } = this.props
    const ccIcon = typeof icon === 'string' ? <Icon type={icon} /> : icon
    let coloredCardContent

    const errorPanel = (
      <div className="error-panel" onClick={onClick}>
        <Icon type="frown" />
        <p>Could not load data.</p>
      </div>
    )

    const loadingPanel = (
      <Skeleton
        onClick={onClick}
        active
        paragraph={{ rows: 2, width: '100%' }}
        title={false}
      />
    )

    const coloredCardPanel = (
      <div onClick={onClick}>
        <div className="card-header">
          <div className="card-title">{title}</div>
          <div className={`card-header-stats card-header-stats-${color}`}>{headerStats}</div>
        </div>
        <div className="card-body">
          <div className="card-number">
            {unit === '$' && <span>$ </span>}
            {number || number === 0 ? number : '----'}
            {unit !== '$' && <span> {unit}</span>}
          </div>
          <div className={`card-icon icon-color-${color}`}>{ccIcon}</div>
        </div>
        <div className="card-footer">
          <div className={`card-color color-${color}`} />
          <div className="card-footer-stats">{footerStats}</div>
        </div>
      </div>
    )

    if (error) {
      coloredCardContent = errorPanel
    } else if (loading) {
      coloredCardContent = loadingPanel
    } else {
      coloredCardContent = coloredCardPanel
    }

    return <div className="colored-card">{coloredCardContent}</div>
  }
}

export default ColoredCard
